// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__3m69Q","link":"link__2c9Jo","section":"section__3WY2u","c":"c__22oH_","subtitle":"subtitle__Gdx6C","image":"image__3XcR_","buttons":"buttons__2iQQT"};